/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetSettingsContainer_appWidget$ref: FragmentReference;
export type WidgetSettingsContainer_appWidget = {|
  +id: string,
  +name: ?string,
  +type: ?string,
  +settings: ?string,
  +$refType: WidgetSettingsContainer_appWidget$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetSettingsContainer_appWidget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "settings",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '407aff42f3fe283896873dd0d0931647';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Widgets/__generated__/WidgetSettingsContainer_appWidget.graphql.js